import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  Form,
  Input,
  Modal,
  Button,
  Container,
  FormGroup,
  ModalBody,
  ModalHeader,
  FormFeedback,
  InputGroup,
} from "reactstrap";
import { get } from "lodash";
import Loader from "react-loaders";
import { toast, ToastContainer } from "react-toastify";
import middlewareConstants from "../../shared/middleware-constant";
import { Helpers } from "../../shell/components/onboarding/bse/halper";
import { middlewareService, postDownloadApi } from "../../shared/service";
import PreviewModal from "../../shell/components/onboarding/PreviewModal";
import { addBankAccountApi, getThirdPartyData, getUploadedDocsList, updateThirdPartyData } from "../../waitlist/services/waitlist-service";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import { utils } from "../../core/helpers/utils";

var pollingCount = 1;

export default function KycBankContent(props) {
  // const { areAllDocsUploaded } = props;

  const [show, setShow] = useState(false);
  const [bankDoc, setBankDoc] = useState("");
  const [bankDocData, setBankDocData] = useState();
  const [bankAccNum, setBankAccNum] = useState("");
  const [accNum, setAccNum] = useState("");
  const [accNum2, setAccNum2] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [isSendingMoney, setSendingMoney] = useState(false);
  const [pennyMsg, setPennyMsg] = useState("");
  const [ifscNum, setIfscNum] = useState("");
  const [nameInBank, setNameInBank] = useState("");
  const [bankType, setBankType] = useState("Saving Bank");
  const [pan, setPan] = useState(props.panValue);
  const [bankAddSuccessModal, setBankAddSuccessModal] = useState(false);
  const [showAccMisMatchPopUp, setShowAccMisMatchPopUp] = useState(false);
  const [uploadedBanks, setUploadedBanks] = useState([]);
  const [bankPresent, setBankPresent] = useState(false);
  const [previewData, setPreViewData] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [bankAccVarified, setBankAccVarified] = useState(false);
  const [uploading, setUploading] = useState([]);
  const [maxFileSizeCheck, setMaxFileSizeCheck] = useState([]);
  const [uploaded, setUploaded] = useState([]);
  const [docTypes, setDocTypes] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [fileData, setFileData] = useState();
  const [isAllDocsUploaded, setIsAllDocsUploaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { setReupload, areAllDocsUploaded } = props;
  const [showUploadDocs, setUploadDocs] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);
  const [inputType, setInputType] = useState('text');
  const [inputType1, setInputType1] = useState('text');
  const [bankNumMatch, setBankNumMatch] = useState("");
  const [ifscValid, setIfscValid] = useState("");
  const [nameError, setNameError] = useState('');
  const [isBankVerified, setIsBankVerified] = useState(true);
  const [product, setProduct] = useState(props?.product);
  const [bankDocFlow, setBankDocFlow] = useState(false);

  function toggle() {
    setShow(!show);
    setIsAllDocsUploaded(true);
  }

  const setIfsc = (val) => {
    setIfscValid('true');
    setIfscNum(val.toUpperCase());
  };

  const accNameMisMatchPopUp = () => {
    setShowAccMisMatchPopUp(!showAccMisMatchPopUp);
  };

  const closeDocumentModal = () => {
    setIsAllDocsUploaded(false);
  };

  const bankSuccessAddedPopUp = () => {
    setBankAddSuccessModal(!bankAddSuccessModal);
    props.moveNextTab();
  };

  const checkAccountNumber = (e) => {
    let accNo = e.target.value && e.target.value.trim();
    accNo = accNo && accNo.replace(/[^0-9]/g, "");
    if (accNo.length <= 16) {
      setAccNum(accNo);
      setBankAccNum(accNo);
    } else {
      toast.error("account number should not be more than 16 digits");
    }
  };

  const checkAccountNumber2 = (e) => {
    let num =
      e.target.value &&
      e.target.value.replace(/[^0-9]/g, "") &&
      e.target.value &&
      e.target.value.trim();
    setBankNumMatch("true");
    setAccNum2(num);
  };

  const replaceNum = () => {
    if(bankNumMatch === 'false'){
      setBankAccNum("");
    }
    setInputType('text')
  };

  const replaceDots = () => {
    setInputType('password')
  }

  const replaceNum1 = () => {
    if(bankNumMatch === 'false'){
      setAccNum2("");
    }
    setInputType1('text')
  };

  const replaceDots1 = () => {
    setInputType1('text')
  }

  const emptyIfsc = () => {
    if(ifscValid === 'false') {
      setIfscNum("");
    }
  }

  const onBankDocUpload = (e) => {
    setBankDoc(e.target.files[0].name);
    setBankDocData(e.target.files[0]);
    // if (e.target.files.length > 0) {
    //   var src = URL.createObjectURL(e.target.files[0]);
    //   var preview = document.getElementById("file-ip-bankdoc");
    //   preview.src = src;
    //   preview.style.display = "block";
    // }
    confirmDoc(e.target.files[0], 'bank')
  };

  const checkName = (e) => {
    let userName = e.target.value;
    setNameInBank(userName);
  };

  const verifyBankType = (e) => {
    let banktype = e.target.value;
    setBankType(banktype);
  };

  const onVerify = () => {
    let tmpAccNo1 = accNum;
    let tmpAccNo2 = accNum2;
    var ifscRegEx = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    if ((nameInBank === '') ||
    (tmpAccNo1 !== tmpAccNo2) ||
    (!ifscRegEx.test(ifscNum))) {
      if (nameInBank === '') {
        setNameError("Name is mandatory");
        // return;
      }
      if (tmpAccNo1 !== tmpAccNo2) {
        setBankNumMatch("false");
      }
      if (!ifscRegEx.test(ifscNum)) {
        setIfscValid('false');
        // return;
      }
    } else {
      setBankAccNum(accNum);
      setBankNumMatch("true");
      setIfscValid('true');
      addPenny();
    } 
  };

  const confirmDoc = (fileData, type) => {
    if (fileData) {
      var name = fileData.name;
      var tempUploading = uploading;
      var tempUploaded = uploaded;
      var tempMaxFileSizeCheck = maxFileSizeCheck;

      if (tempUploading.indexOf(name) === -1) {
        tempUploading.push(name);
      }

      if (tempUploaded.indexOf(name) !== -1) {
        tempUploaded.splice(tempUploaded.indexOf(name), 1);
      }

      if (tempMaxFileSizeCheck.indexOf(name) !== -1) {
        tempMaxFileSizeCheck.splice(tempMaxFileSizeCheck.indexOf(name), 1);
      }

      if (fileData.size > 20000000) {
        var uploading2 = uploading;
        var maxFileSizeCheck2 = maxFileSizeCheck;

        if (uploading2.indexOf(name) !== -1) {
          uploading2.splice(uploading.indexOf(name), 1);
        }

        if (maxFileSizeCheck2.indexOf(name) === -1) {
          maxFileSizeCheck2.push(name);
        }

        setUploading(tempUploading);
        setMaxFileSizeCheck(maxFileSizeCheck2);

        return;
      }

      docUpload(fileData.name, fileData, type);
    }
  };

  const docUpload = (name, file, type) => {
    var tempUploading = uploading;
    var tempUploaded = uploaded;
    var tempDocTypes = docTypes;
    var tempMaxFileSizeCheck = maxFileSizeCheck;
    let email = "";

    if (!tempMaxFileSizeCheck || !tempMaxFileSizeCheck.length) {
      let fileListTemp = [...fileList];
      fileListTemp.push(file);

      setFileData(file);
      setFileList(fileListTemp);
      setUploaded(tempUploaded);
      setUploading(tempUploading);

      uploadDocsIndia(type, email, pan, file, name).then((response) => {
        var uploading2 = uploading;
        var uploaded2 = uploaded;

        if (!response || !response.success) {
          if (uploading2.indexOf(name) !== -1) {
            uploading2.splice(uploading.indexOf(name), 1);
          }

          setUploading(uploading2);

          let msg = response && response.error;
          return toast.error(
            "Special characters are not allowed in filename."
          );
        }
        getUploadedDocsListApi(pan);
        if (uploading2.indexOf(name) !== -1) {
          uploading2.splice(uploading.indexOf(name), 1);
        }

        if (uploaded2.indexOf(name) === -1) {
          uploaded2.push(name);
          tempDocTypes.map((doc) => {
            if (doc.type === name) {
              doc.status = "uploaded";
            }
          });
        }

        if (!isBankVerified) {
          let payload = {
            name: nameInBank,
            accountNumber: bankAccNum,
            ifsc: ifscNum,
            accountType: Helpers.accountTypeCode(bankType),
            pan: props.panValue ?
              props.panValue : props.userProfile && 
              props.userProfile.pan ? props.userProfile.pan :
              props.thirdpartyData?.data?.pan ? props.thirdpartyData.data.pan :
              pan,
            product: "orobonds",
          };      
          addBankAccountApi(payload, {"X-product": `orobonds:default`});
        }
        setUploaded(tempUploaded);
        setUploading(tempUploading);
        setDocTypes(tempDocTypes);
        setShow(true);
        setBankAddSuccessModal(true);
        setBankDocFlow(true);
        setConfirm(true);
        setAnalyticsEvent(window.location.pathname + window.location.hash,
          "Bank_Verified"
        );
      });
    }
  };
  

  const confirmBankDetails = (type) => {
    // setShow(true);
    // setConfirm(true);
    if (type === 'next') {
      setSuccessMsg("Bank verification is under process");
    }
    bankSuccessAddedPopUp();
  }

  useEffect(() => {
    if (bankAddSuccessModal) {
      setAnalyticsEvent("SIkycBankverified");

      // facebook pixel integration

      props.updateDocStatus();
      setTimeout(() => {
        props.moveNextTab();
      }, 2500)
    }
  }, [bankAddSuccessModal])

  const showBankInputSec = () => {
    setShowAccMisMatchPopUp(false);
    props.setReupload(true);
  }

  const thirdPartyData = async (result) => {
    const payload = utils.encryptedPayload({
      accountNumber: result && result.accountNumber,
      ifscCode: result && result.ifsc,
      accountType: result && result.accountType,
      nameInBank: result && result.name,
      bankName: result && result.bankName,
      branchName: result && result.branchName,
      productName: "oroBonds",
      bankVerified: result.verification ? 
        Object.assign({}, result.verification) :
          {status: "verification under process"},
      productName: 'oroBonds',
    });

    return updateThirdPartyData(payload, {"X-product": `orobonds:default`, 'x-encrypted-data': true })
      .then((resp) => {
        return resp;
      });
  };

  const uploadDocsIndia = (docType, email, pan, doc, fileName) => {
    const formData = new FormData();
    fileName
      ? formData.append("useruploadcandocs", doc, fileName)
      : formData.append("useruploadcandocs", doc);
    formData.append("name", docType);

    const requestOptions = {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {
        "X-product": `orobonds:default`,
        "use-pkey" : false
      }
    };

    return fetch(
      process.env.REACT_APP_REPORTS_API_URL +
        "/users/uploadDocs?email=" +
        email +
        "&pan=" +
        pan +
        "&type=" +
        docType,
      requestOptions
    )
      .then((response) => response.json())
      .then((portfolioResponse) => {
        return portfolioResponse;
      });
  };

  const showDocsSection = () => {
    setUploadDocs(true);
    setShowAccMisMatchPopUp(false);
  }

  const getUploadedDocsListApi = (inputPan) => {
    let tmpBankList;
    let tmpDocList;
    getUploadedDocsList(
      { payload: utils.encryptedPayload(inputPan) }, 
      {"X-product": `orobonds:default`})
      .then((result) => {
        const response = utils.parsePayload(result);
        if (!response.data || !response.success) {
          // return toast.error("No documents found.");
        }
        if (response.data && response.data.length) {
          tmpBankList = response.data.filter((x) => x.type === "bank")[0];
          if (tmpBankList) {
            setUploadedBanks(tmpBankList);
            setBankPresent(true);
          }
          areAllDocsUploaded && areAllDocsUploaded(get(response, "data", []));
        }
      });
  };

  const previewImage = () => {
    const _url = "/users/v2/downloadDocs";
    let tmpBank = uploadedBanks;
    const payload = {
      filename: tmpBank && tmpBank.data ? tmpBank.data : "",
    };
    postDownloadApi(_url, payload).then((fileResponse) => {
      if (!fileResponse || fileResponse.err) {
        // toast.error(
        //   fileResponse.msg || "Not able to fetch data. Please try again"
        // );
        return;
      }
      const data = URL.createObjectURL(fileResponse);
      setPreViewData(data);
      setPreviewOpen(true);
    });
  };

  const closePreview = () => {
    setPreviewOpen(false);
  };

  const addPenny = () => {
    let acc1 = accNum;
    let acc2 = accNum2;
    let _url = "/bse/banks/verify";
    if (!nameInBank || !ifscNum || !accNum) {
      toast.error("Please check all entries");
      return;
    }
    if (acc1 !== acc2) {
      toast.error("Account number didn't match");
      return;
    }

    let params = {
      ifsc: ifscNum,
      name: nameInBank,
      accountNumber: bankAccNum,
    };
    setSendingMoney(true);

    let requestOptions = middlewareConstants.requestWithCredentialsJson;
    requestOptions.headers["X-product"] = `orobonds:${product}`
    requestOptions.body = JSON.stringify(params);

    middlewareService
      .servicePost(process.env.REACT_APP_API_URL + _url, requestOptions)
      .then((resp) => {
        if (resp.allowBank) {
          setPennyMsg(resp.error);
          addBankAccount();
        }

        if (
          !resp ||
          !resp.success ||
          !resp.result ||
          !resp.result.validationRequestId
        ) {
          setSendingMoney(false);
          return onVerifyStatusFalse();
        }

        _doPolling(get(resp, 'result.validationRequestId', ""));
      });
  };

  const addBankAccount = () => {
    let tmpIfscCode = ifscNum;
    let tmpBankNum = bankAccNum;
    let tmpNameInBank = nameInBank;
    let tmpAccType = bankType;

    if (!tmpNameInBank || !tmpIfscCode || !tmpBankNum || !tmpAccType) {
      return toast("Please check all entries");
    }

    let payload = {
      name: tmpNameInBank,
      accountNumber: tmpBankNum,
      ifsc: tmpIfscCode,
      accountType: Helpers.accountTypeCode(tmpAccType),
      pan: props.panValue ?
        props.panValue : props.userProfile && 
        props.userProfile.pan ? props.userProfile.pan :
        props.thirdpartyData?.data?.pan ? props.thirdpartyData.data.pan :
        pan,
      product: "orobonds",
    };
    setSendingMoney(true);

    addBankAccountApi(payload, {"X-product": `orobonds:default`})
      .then((response) => {
        if (
          response &&
          response.success &&
          Object.keys(response.result).length
        ) {                                  
          setBankAddSuccessModal(true);
          setSendingMoney(false);
          thirdPartyData(response.result).then(
            response => {
              if (!response || !response.success) {
                return toast.error("Error: Unable to update bank details. Please contact connect@orowealth.com")
              }
              setAnalyticsEvent(window.location.pathname + window.location.hash,
                "Bank_Verified"
              );
            }
          );
        } else {
          setSendingMoney(false);
          setBankAccVarified(false);
          let msg =
            response && response.message
              ? response.message
              : "Error while adding account";
          msg = msg.charAt(0).toUpperCase() + msg.slice(1);
          setPennyMsg(msg);
          setShowAccMisMatchPopUp(true);
          thirdPartyData({
            accountNumber: bankAccNum,
            ifsc: ifscNum,
            accountType: bankType,
            name: nameInBank,
            bankVerified: {
              status: "verification under process"
            }
          }).then(
            response => {
              if (!response || !response.success) {
                return toast.error("Error: Unable to update bank details. Please contact connect@orowealth.com")
              }
            }
          );
        }
      });
  };

  const _doPolling = (validationReqId) => {
    let id = setInterval(() => {
      verifYPennyStatus(validationReqId, id);
    }, 4000);
  };


  const _clearTimer = (id) => {
    pollingCount = 1;
    if (id) clearInterval(id);
  };

  const onVerifyStatusFalse = (intervalId) => {
    thirdPartyData({
      accountNumber: bankAccNum,
      ifsc: ifscNum,
      accountType: bankType,
      name: nameInBank,
      bankVerified: {
        status: "verification under process"
      }
    }).then(
      (response) => {
        if (!response || !response.success) {
          return toast.error("Error: Unable to update bank details. Please contact connect@orowealth.com");
        }
        setIsBankVerified(false);
        setSendingMoney(false);
        _clearTimer(intervalId);
        setPennyMsg('Your bank verification failed. Please upload a copy of your bank proof.')
        setShowAccMisMatchPopUp(true);
      }
    )
  }

  const verifYPennyStatus = (validationReqId, intervalId) => {

    if (!validationReqId) {
      return;
    }

    let _url = "/bse/banks/verify/status?validationRequestId=" + validationReqId;

    let requestOptions = middlewareConstants.requestWithCredentials;
    requestOptions.headers["X-product"] = `orobonds:default`;

    middlewareService.serviceGet(process.env.REACT_APP_API_URL + _url, requestOptions)
      .then((response) => {
        if(get(response, 'result', '') === 'pending') {
          if (pollingCount >= 5) {
            return onVerifyStatusFalse(intervalId);
          }
          pollingCount++;
          return;
        }
        if (response && (response.result === "active" || response.allowBank)) {
          if (response.allowBank) {
            setPennyMsg(response.error);
          }
          setSendingMoney(false);
          _clearTimer(intervalId);
        
          addBankAccount();
          setBankAccVarified(true);
          return;
        }
        return onVerifyStatusFalse(intervalId);
      });
  };

  const getRecentPan = () => {
    let data;
    let tmpPan;

    getThirdPartyData({"X-product": `orobonds:default`, 'x-encrypted-data': true})
      .then((result) => {
        const response = utils.parsePayload(result);
        if (response && response.success && response.data) {
          data = response.data;
          tmpPan = data && data.pan ? data.pan : "";
          setPan(tmpPan.toUpperCase());
          tmpPan && getUploadedDocsListApi(tmpPan);
        }
      });
  };

  useEffect(() => {
    let mobile = window.matchMedia("(max-width: 768px").matches;
    setIsMobile(mobile);
    getRecentPan();
  }, []);

  return (
    <>
      <div className="kyc-content-block">
        <Container className="form-container justify-content-center">
          <Row>
            <Col>
              {!isSendingMoney && !showUploadDocs && (
                <div
                  className={!isMobile ? "adress-banner border" : "adress-banner-mob border"}
                >
                  <div className="banner-inner">
                    <Form className="form-class">                      
                      <h5 style={{ color: "black" }} className="mt-3">
                        <strong className="text-capitalize">Verify your bank account</strong>
                      </h5>                   
                      <div className="inner">
                        {/* {bankPresent ? (
                          <>
                            <div className="px-1 d-flex text-muted mt-3 justify-content-center align-items-center">
                              <img
                                style={{ width: "25px", height: "25px" }}
                                src={success}
                                alt=""
                              />
                              <h6 className="text-muted ml-3">
                                Your Bank is already uploaded!
                              </h6>
                            </div>
                          </>
                        ) : null} */}
                          <>
                            <InputGroup>
                              <Input
                                style={isMobile ? {fontSize: "13px"} : {}}
                                type="text"
                                name="nameInBank"
                                id="nameInBank"
                                placeholder="Enter your Name*"
                                value={nameInBank}
                                className="mt-3" 
                                onChange={(e) => checkName(e)}
                              />
                              <FormFeedback invalid={nameError !== ''}>{nameError}</FormFeedback>
                            </InputGroup>

                            <FormGroup>
                              <Input
                                style={isMobile ? {fontSize: "13px"} : {}}
                                type={inputType}
                                name="accNumber"
                                id="accNumber1"
                                placeholder="Enter your bank account number*"
                                maxLength={16}
                                value={bankAccNum}
                                invalid={bankNumMatch === 'false'}
                                onChange={(e) => checkAccountNumber(e)}
                                onBlur={() => replaceDots()}
                                className="mt-5 mb-2"
                              ></Input>
                            </FormGroup>

                            <InputGroup>
                              <Input
                                style={isMobile ? {fontSize: "13px"} : {}}
                                type={inputType1}
                                name="accNumber2"
                                id="accNumber2"
                                maxLength={16}
                                placeholder="Confirm your bank account number*"
                                invalid={bankNumMatch === 'false'}
                                onBlur={() => replaceDots1()}
                                onChange={(e) => checkAccountNumber2(e)}
                                className="mt-5 mb-2"
                                value={accNum2}
                              ></Input>
                              <FormFeedback invalid={bankNumMatch === 'false'}>
                                Account fields do not match. Please enter correct account number
                              </FormFeedback>
                            </InputGroup>

                            <InputGroup>
                              <Input
                                style={isMobile ? {fontSize: "13px"} : {}}
                                type="text"
                                placeholder="Enter IFSC code*"
                                id="ifsccode"
                                name="ifsccode"
                                value={ifscNum}
                                invalid={ifscValid === 'false'}
                                className="mt-5 mb-2"
                                onChange={(e) => setIfsc(e.target.value)}
                              ></Input>
                              <FormFeedback invalid={ifscValid === 'false'}>
                              Please enter a valid IFSC number
                            </FormFeedback>
                            </InputGroup>
                            <FormGroup>
                            <select
                              class="form-control account-type w-100 mt-5 mb-2"
                              id="acc"
                              onChange={(e) => verifyBankType(e)}
                            >
                              <option value="Saving Bank" selected>
                                Saving Bank
                              </option>
                              <option value="Current Bank">Current Bank</option>
                              <option value="NRE Account">NRE Account</option>
                              <option value="NRO Account">NRO Account</option>
                            </select>
                          </FormGroup>
                          </>
                        {/* ) : null} */}
                      </div>
                          <div className="verify-preview">
                            
                              {!bankAccVarified ? (<Button
                                color="#22c979"
                                className={"mt-3 " + (
                                  (nameInBank === '' ||
                                  bankAccNum === '' ||
                                  accNum2 === '' ||
                                  ifscNum === '') ? "disabled" : ""
                                )}
                                onClick={onVerify}
                                disabled={
                                  nameInBank === '' ||
                                  bankAccNum === '' ||
                                  accNum2 === '' ||
                                  ifscNum === ''
                                }
                              >
                                Verify
                              </Button>
                             ) : (
                              <Button
                                color="#22c979"
                                className="mt-3"
                                onClick={() => confirmBankDetails()}
                              >
                                Confirm
                              </Button>
                            )}
                          </div>
                    </Form>
                  </div>
                </div>
              )}
              {isSendingMoney && (
                <Col className="text-center mt-5">
                  <div className="primary">
                    <Loader
                      color="#19d1a5"
                      type="ball-clip-rotate"
                      className="loader-primary"
                    />
                  </div>
                  <div className="font-42 font-weight-bold">
                    We are verifying your bank account XXXXXXXX
                    {bankAccNum.substr(bankAccNum.length - 4)}
                  </div>
                </Col>
              )}
              {showUploadDocs && (
                <div
                className={!isMobile ? "adress-banner border" : "adress-banner-mob border"}
              >
                <div className="d-flex flex-column align-items-center">
                  <p className="font-size-18 font-weight-semi-bold">
                    Upload Bank Proof to verify
                  </p>
                  <p>Please upload a photo of any one of the following</p>
                  <ol className="text-left">
                    <li>Cancelled cheque</li>
                    <li>Bank statement</li>
                    <li>Passbook first page</li>
                  </ol>
                  <label>
                    <div className="upload-front mt-2 mb-3">
                      <img className="mt-2" src={process.env.REACT_APP_IMAGES_PATH + "uploadimage.webp"} alt="uploadimage-icon"/>
                      {bankDoc || bankPresent ? (
                        <h6 className="text-muted p-2 mt-3">
                          Reupload your bank proof<span className="text-danger">*</span>
                        </h6>
                      ) : (
                        <h6 className="text-muted p-2 mt-3">
                          Upload your bank proof
                          <span style={{ color: "red" }}>*</span>
                        </h6>
                      )}
                      <input
                        type="file"
                        id="upload"
                        name="bank"
                        style={{ display: "none" }}
                        onChange={(e) => onBankDocUpload(e)}
                        className="doc-input"
                        accept=".png, .pdf, .jpg, .jpeg"
                      />
                    </div>
                  </label>
                  <Button 
                    color="secondary"
                    disabled={!bankDocData}
                    onClick={() => confirmBankDetails('next')}>
                    Next
                  </Button>
                </div>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        centered
        isOpen={showAccMisMatchPopUp}
        // toggle={accNameMisMatchPopUp}
        className="modal-md acc-mismatch"
        // size="lg"
      >
        {/* <ModalHeader
          toggle={accNameMisMatchPopUp}
          className="pt-3"
        ></ModalHeader> */}
        <ModalBody className="text-center bse p-4">
          <img src={process.env.REACT_APP_IMAGES_PATH + "failure.webp"} alt="" />
          <div className="font-size-30 font-weight-bold mt-3">Sorry!</div>
          <div className="font-size-12 font-weight-bold mt-3 mb-3">
            {pennyMsg}
          </div>
          <div className={"d-flex justify-content-around " + (isMobile && "flex-column mx-2")}>
            <Button outline color="secondary" onClick={showDocsSection}
              className={(isMobile && "m-3")}
            >
              Upload Bank Proof to verify
            </Button>
            <Button color="secondary" onClick={showBankInputSec}
              className={(isMobile && "mx-3")}
            >
              Re-Enter Account number
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        centered
        isOpen={bankAddSuccessModal}
        toggle={bankSuccessAddedPopUp}
        className="modal-md"
      >
        <ModalHeader
          toggle={bankSuccessAddedPopUp}
          className="pt-3"
        ></ModalHeader>
        <ModalBody className="text-center bse p-3">
          {successMsg ?
            <>
              <img src={process.env.REACT_APP_IMAGES_PATH + "Verification.webp"} alt="" />
              <div className="font-size-12 font-weight-bold">
              {successMsg}
              </div>
            </> :
            <>
              <img src={process.env.REACT_APP_IMAGES_PATH + "success.webp"} alt="" />
              <div className="font-size-30 font-weight-bold">Congratulations!</div>
              <div className="font-size-12 font-weight-bold">
                {bankDocFlow ? "Your bank proof has been uploaded successfully!" :
                "Your bank details has been added successfully!"}
              </div>
            </>
          }
        </ModalBody>
      </Modal>

      <Modal
        centered
        isOpen={isAllDocsUploaded}
        toggle={closeDocumentModal}
        className="modal-md"
      >
        <ModalHeader toggle={closeDocumentModal} className="pt-3"></ModalHeader>
        <ModalBody className="text-center bse p-3">
          <img className="mt-3 mb-3" src={process.env.REACT_APP_IMAGES_PATH + "alldocs.webp"} alt="" />
          <div className="font-size-30 font-weight-bold mt-4">
            Thank you for submitting your documents
          </div>
          <div className="font-size-18 mt-4">
            Our team will reach you out once the verification process is done
          </div>

          <Button className="mt-4 done-button" onClick={closeDocumentModal}>
            DONE
          </Button>
        </ModalBody>
      </Modal>

      {previewOpen && (
        <PreviewModal
          close={closePreview}
          isOpen={previewOpen}
          preview={previewData}
        />
      )}
      <ToastContainer />
    </>
  );
}